module.exports = __webpack_public_path__ + "img/53400.90181978.jpg";